import {extractorUtil} from "../../util/extractorUtil";
import {Feature} from "../../feature";
import {rGroupFinder} from "../../util/rGroupFinder";
import {MolecularGraph} from "../../graph"

export const rxhExtractor = {
    extract: (e: string, name: string, graph: MolecularGraph) => {
        const xAtoms = extractorUtil.getFunctionalGroupRootsWithElement(e, graph);
        const features: Feature[] = [];
        while (xAtoms.length > 0) {
            const x = xAtoms.pop()!;
            const bonds = graph.getBondsAttachedTo(x);

            // rxh (Alcohol and Thiol) should have exactly 2 bonds total:
            // the R-group connector and an H (explicit or implicit)
            const totalBonds = bonds.length + x.implicitH;
            if(totalBonds === 2) {

                // Find the explicit hydrogen that is only connected to the x
                const hydrogenBonds = bonds.filter(b => {
                    const otherAtom = b.getOtherAtom(x);
                    const bondsOnOtherAtom = graph.getBondsAttachedTo(otherAtom);
                    return bondsOnOtherAtom.length === 1 && otherAtom.symbol === "H";
                });

                if (hydrogenBonds.length === 1) {
                    // Explicit hydrogen case
                    const a = [x, hydrogenBonds[0].getOtherAtom(x)];
                    const r = rGroupFinder.get(graph, a);
                    features.push({name: name, atoms: a, connections: r});
                } else if (x.implicitH === 1 && bonds.length === 1) {
                    // Implicit hydrogen case - H is hidden but still part of the functional group
                    const a = [x];
                    const r = rGroupFinder.get(graph, a);
                    features.push({name: name, atoms: a, connections: r});
                }
            }
        }
        return features;
    }
}
